import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCostCenterType,
  getParticularPage,
  getNext,
  getPrevious,
  createCostCenterType,
  updateCostCenterType,
  handleSearch,
} from "./thunk";

const initialState = {
  costCenterTypes: [],
  edit: false,
  costCenterType: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCostCenterType: false,
  loadingNext: false,
  showCreateModal: false,
};

export const costCenterTypeSlice = createSlice({
  name: "costCenterType",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    costCenterTypeEditSuccess: (state, action) => {
      state.edit = true;
      state.costCenterType = state.costCenterTypes.find((costCenterType) => costCenterType.id === action.payload);
    },
    clearAllCostCenterType: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCostCenterType = false;
      state.costCenterType = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCostCenterType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCostCenterType.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCostCenterType.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenterType.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCostCenterType.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenterType.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCostCenterType.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCostCenterType = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenterType.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCostCenterType = false;
        state.costCenterTypes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenterType.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCostCenterType = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, costCenterTypeEditSuccess, clearAllCostCenterType } =
  costCenterTypeSlice.actions;

export default costCenterTypeSlice.reducer;
